import Page from "./pages/Page";

function App() {
  return (
    <div className="App">
      <Page />
    </div>
  );
}

export default App;
